import { get } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import useGetSharedData from './useGetSharedData';
import { createStore } from 'jotai';
import { useDispatch } from 'react-redux';
import { changeIsSharingPage } from '@store/common/actions';
import { setCurrentActiveDashboard } from '@src/store/tempDashboard/actions';
import { useResetForPreset } from '@src/hooks/useResetForPreset';
import { isSharingAtom } from '@src/atoms/pageMeta';
import { useParams } from 'react-router-dom';

// HoC wrapper to apply shared data on the page state
function ShareHoc({ children, applyCallback, initStore = createStore }) {
  const { id } = useParams();
  const { ready, refetch, data } = useGetSharedData({ id, applyCallback });

  const dispatch = useDispatch();

  useEffect(() => {
    refetch();
    // TODO: review and cleanup
    // for compatibility with current workflow
    // we can remove this after migrating all pages to new share
    dispatch(changeIsSharingPage(true));
    return () => {
      dispatch(changeIsSharingPage(false));
    };
  }, []);

  useResetForPreset();

  // intialize jotai store with default state
  const store = useMemo(() => {
    if (ready) {
      const rawState: any = get(data, 'state', '{}');
      const state = JSON.parse(rawState);
      dispatch(setCurrentActiveDashboard({ ...data, state }));
      const store =  initStore(state);
      store.set(isSharingAtom, true);
      return store;
    }
    return null;
  }, [data, ready, initStore]);

  return ready ? children({ store }) : <>Loading...</>;
}

export default ShareHoc;
